module.exports = __webpack_public_path__ + "media/images/help/line/eyecatch-point-4-04c4161c1c3c2591994755c8c49f4a18.jpg";